import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.028 3.062A10.75 10.75 0 0 1 12 1.25a.75.75 0 0 1 .75.75v9.25H22a.75.75 0 0 1 .75.75A10.75 10.75 0 1 1 6.028 3.062m5.222-.282a9.25 9.25 0 1 0 9.97 9.97H12a.75.75 0 0 1-.75-.75zm4.083-.24a.75.75 0 0 1 .987-.387 10.8 10.8 0 0 1 5.548 5.568.75.75 0 1 1-1.376.598 9.3 9.3 0 0 0-4.773-4.792.75.75 0 0 1-.386-.987",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }